"use strict";

var e,
    r = require("./index-7ebd9a2e.js"),
    t = require("react"),
    p = (e = t) && "object" == typeof e && "default" in e ? e.default : e;

exports._propTypes = r.propTypes, exports._react = p;